import React, { useState, useEffect, useRef, useCallback } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import './Journey.css';

// ─── Data ─────────────────────────────────────────────────────────────────────

const professionalData = [
  {
    id: 1, category: 'professional',
    title: 'Geo AI Engineer',
    company: 'WhereSoft Technologies Pvt Ltd', website: 'https://www.wheresoft.in/',
    period: 'July 2025 – Present',
    location: 'Hyderabad, India', locationType: 'Work From Office',
    lat: 17.531978623811707, lng: 78.38876851411067,
    timelineSummary: 'Actively developing "WhereOne," a web-based, cloud-native geospatial platform featuring agentic AI for prompt-based GIS processing.',
    popupDetails: 'At WhereSoft Technologies, I work at the intersection of GIS and AI, training and deploying deep learning models for object detection and segmentation projects. I have contributed to palm tree detection, agricultural pit detection, building footprint extraction, and pond boundary segmentation using Mask Rcnn, YOLO and Vision Transformer models such as SAM. I deploy models on FastAPI backends and am developing LLM-based AI agents with local RAG (using LangChain, Qdrant, Redis, MinIO and PostgreSQL) and cloud based LLM APIs (NVIDIA NIM, Google Gemini API etc) as well as local LLMs (Ollama).',
    skills: ['Deep Learning (YOLO, Mask R-CNN, SAM)', 'Python', 'ArcPy', 'FastAPI', 'GDAL', 'RAG', 'rasterio', 'WhiteboxTools', 'geoai-py'],
    images: ['images/wheresoft.jpg',],
  },
  {
    id: 2, category: 'professional',
    title: 'Junior Data Analyst',
    company: 'Garudalytics Private Limited', website: 'https://garudalytics.com/',
    period: 'March 2024 – June 2025',
    location: 'Hyderabad, India', locationType: 'Work From Office',
    lat: 17.489294420431825, lng: 78.39274212622732,
    timelineSummary: 'Analyzing geospatial datasets and developing custom GeoAI tools for defense and commercial applications.',
    popupDetails: 'At Garudalytics, I analyzed geospatial datasets using Python, ArcGIS Pro, and QGIS while developing custom geoprocessing tools. I deployed object detection models in offline environments for defense projects and contributed to GeoAI tools for their flagship product GSM, including heatwave prediction, flood impact analysis, building footprint extraction, wildfire analysis, and crop yield prediction. I also developed Disha, a QGIS plugin for least-cost route calculation.',
    skills: ['ArcGIS Pro', 'QGIS', 'Python', 'Django', 'Deep Learning', 'PyQt5', 'GeoAI'],
    images: ['images/garudalytics_group_pic.jpg'],
  },
  {
    id: 3, category: 'professional',
    title: 'Chanakya Postgraduate Fellowship',
    company: 'IIT Tirupati Navavishkar I-Hub Foundation', website: 'https://iittnif.com/',
    period: 'June 2024 – Aug 2024',
    location: 'Tirupati, Andhra Pradesh, India', locationType: 'Remote',
    lat: 13.714993125345645, lng: 79.59343064666696,
    timelineSummary: 'Project done for coastal surveillance using deep learning for object detection.',
    popupDetails: 'During my Chanakya Fellowship at IIT Tirupati, I developed deep learning-based YOLOv8n object detection models for coastal surveillance systems, implementing zone-based detection capabilities and building an automated Telegram alert system for real-time security monitoring.',
    skills: ['Python', 'Deep Learning', 'Object Detection', 'Telegram Bot Development'],
    images: [],
  },
  {
    id: 4, category: 'professional',
    title: 'Geospatial Associate',
    company: 'Social Responsibility Asia (SR Asia)', website: 'https://sr-asia.org/',
    period: 'Oct 2023 – Dec 2023',
    location: 'Chandrapur, Maharashtra, India', locationType: 'Hybrid',
    lat: 19.816092250078917, lng: 79.33126694910639,
    timelineSummary: 'Field-based GIS work on Baseline Socio-Economic Survey for coal-mine affected villages.',
    popupDetails: 'At SR Asia, I collected socio-demographic data through field surveys using Survey123, analyzed and prepared maps in ArcGIS Pro, proposed resettlement areas maps, and contributed to Re-Settlement Action Plans for coal-mine affected communities in Chandrapur.',
    skills: ['Survey123', 'ArcGIS Pro', 'Field Surveys', 'Cartography', 'Flood Mapping', 'Suitable Relocation Mapping'],
    images: ['images/sr_asia_certificate.png',],
  },
  {
    id: 5, category: 'professional',
    title: 'Technical Assistant',
    company: 'Reliable Diagnostic Centre',
    period: 'Feb 2022 – July 2022',
    location: 'Purbasthali, West Bengal, India', locationType: 'On-site',
    lat: 23.455375991355826, lng: 88.32622968147946,
    timelineSummary: 'Technical role in medical diagnostics, maintaining data confidentiality and report accuracy.',
    popupDetails: 'Prepared digital diagnostic reports with high accuracy while maintaining strict patient data confidentiality. Streamlined diagnostic services and improved report turnaround times through technical proficiency and rigorous quality assurance protocols.',
    skills: ['Data Management', 'Report Preparation', 'Medical Documentation'],
    images: ['images/technical_assistant_certificate.png',],
  },
];

const educationData = [
  {
    id: 11, category: 'education',
    title: 'M.Sc. Geoinformatics',
    company: 'Bharati Vidyapeeth Institute of Environment Education and Research (BVIEER)', website: 'http://bvieer.bharatividyapeeth.edu/',
    period: '2022 – 2024',
    location: 'Pune, India', locationType: 'On-campus',
    lat: 18.4602171352315, lng: 73.8521164474222,
    cgpa: '8.93',
    timelineSummary: 'Masters program in Remote Sensing and GIS with focus on spatial data science.',
    popupDetails: 'Completed Masters in Geoinformatics at BVIEER, Pune with a CGPA of 8.93. The program combined advanced coursework in Remote Sensing, GIS, Python programming, and spatial analysis with hands-on research projects, solidifying my foundation for professional work in GeoAI.',
    skills: ['Advanced Remote Sensing', 'GIS', 'Python', 'Spatial Analysis', 'Image Processing'],
    images: ['images/My_Convocation_Day.jpg', 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0w1qfjz93XW6nprgY6tZKViiYn1soEwZ-shOiA0hJb0Z_VmrS8lD5J7x9&s=10', 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzEW6n3FzGKUw5RMnzpfrHfwJo_nA6-oWJ1AlkkFtzzMjhu3u6FO5oPZQ&s=10', 'images/field_trip_01.jpeg', 'images/field_trip_02.jpeg', 'images/field_trip_03.jpeg'],
  },
  {
    id: 12, category: 'education',
    title: 'Urban Microclimate Modeling',
    company: 'University of Cologne (Collaboration with BVIEER)', website: 'https://www.uni-koeln.de/',
    period: 'Sep 2022 – Mar 2023',
    location: 'Pune, India', locationType: 'Hybrid',
    lat: 18.4602171352315, lng: 73.8521164474222,
    grade: 'A+',
    timelineSummary: 'International blended diploma program in climate modeling using Envi-Met software.',
    popupDetails: 'Selected as one of eight students at BVIEER for this blended learning program with University of Cologne. Gained expertise in Urban Microclimate Modeling using Envi-Met software, simulating urban climate patterns, heat islands, and environmental conditions.',
    skills: ['Envi-Met', 'Urban Climate Modeling', 'Environmental Analysis', 'Climate Simulation'],
    images: ['images/Fieldwork_cologne_students.jpeg',],
  },
  {
    id: 13, category: 'education',
    title: 'Hons in Geography',
    company: 'Aliah University', website: 'https://aliah.ac.in/',
    period: '2019 – 2022',
    location: 'Kolkata, India', locationType: 'On-campus',
    lat: 22.545741152785286, lng: 88.36860680546062,
    cgpa: '7.66',
    timelineSummary: 'Undergraduate foundation in Geography where I discovered my passion for GIS and Remote Sensing.',
    popupDetails: 'Three transformative years at Aliah University, Kolkata, completing Bachelor in Geography with Honours (CGPA: 7.66). This period was pivotal in discovering my passion for Remote Sensing and GIS, building the spatial thinking foundation that underpins my entire career.',
    skills: ['Geography', 'Physical Geography', 'Remote Sensing Basics', 'GIS Fundamentals'],
    images: ['https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW-TwYEGASq7j0ndusMRTosHnQwN7qxapkWw&s', 'https://dfhe5ze0n4pxu.cloudfront.net/College/Image/Image-1771482699427.jpeg',],
  },
];

const workshopsData = [
  {
    id: 25, category: 'workshops',
    title: 'GeoSmart India 2025',
    company: 'Bharat Mandapam, New Delhi',
    period: 'Dec 2025',
    location: 'New Delhi, India', locationType: 'On-site',
    lat: 28.6189, lng: 77.2413,
    timelineSummary: 'Explored cutting-edge geospatial applications, IoTs, and tools at GeoSmart India 2025 in Bharat Mandapam, New Delhi.',
    popupDetails: 'Seen the cutting-edge geospatial applications, IoTs and tools at GeoSmart India in Bharat Mandapam, New Delhi. The future of location intelligence looks exciting...',
    skills: ['GIS', 'IoT', 'Location Intelligence', 'Geospatial Technology'],
    images: ['https://media.licdn.com/dms/image/v2/D5622AQFGE1ewBTMVqQ/feedshare-image-high-res/B56ZsbrAuYKQAs-/0/1765695820363?e=1788393600&v=beta&t=mVfLa_dW-KYNU9pdOunQ0NPbadGUaCN9xU3UOPvwJpw', 'https://media.licdn.com/dms/image/v2/D5622AQHufXr3iavGQA/feedshare-image-high-res/B56ZsbrAxsIAAs-/0/1765695829968?e=1788393600&v=beta&t=CUCH3Mb8CovlD2xuD25GOrQ-_e8YsEZVbqIyFJ-2rvc', 'https://media.licdn.com/dms/image/v2/D5622AQElge_WVwfgtw/feedshare-image-high-res/B56ZsbrAufIAAo-/0/1765695825144?e=1788393600&v=beta&t=YmMhjaSjkLbDxaXStuHRB46R6511xMvsrSWhqQbBdCY'],
  },
  {
    id: 24, category: 'workshops',
    title: 'Esri India User Conference 2025',
    company: 'Esri India',
    period: 'Sep 2025',
    location: 'Hyderabad, India', locationType: 'On-site',
    lat: 17.42378422371594, lng: 78.46238401853509,
    timelineSummary: 'Attended Esri India UC 2025 — witnessed live GeoAI demos, GIS SDK with Unreal Engine & Unity for immersive flood simulations.',
    popupDetails: 'Had a fantastic day at the Esri India User Conference 2025 in Hyderabad. I was very impressed by the live demos of new GeoAI tools. Seeing GIS SDK integrated with Unreal Engine and Unity to create incredible, real-life flood simulations was a huge highlight for me. It\'s truly amazing how they\'re turning data into powerful, immersive visuals for a better understanding of complex challenges. Got a chance to have a small talk with Agendra Kumar sir (Managing Director of Esri India).',
    skills: ['ArcGIS', 'GeoAI', 'GIS SDK', 'Unreal Engine', 'Unity'],
    images: ['https://media.licdn.com/dms/image/v2/D4D22AQG-ZULkJge7NQ/feedshare-image-high-res/B4DZk0fJdZIEAo-/0/1757522206682?e=1788393600&v=beta&t=ypoW5j2yqJkapTd6sJHWpCYx97eRAR2Szlbv2K_C-7w', 'https://media.licdn.com/dms/image/v2/D4D22AQGI4QeJf7y9RA/feedshare-shrink_1280/B4DZk0fJdRHwAs-/0/1757522206072?e=1788393600&v=beta&t=KlI23w5UXBvOGBLhYHoNVPB4gFzYuc4TA20wbMJUkrI'],
  },
  {
    id: 23, category: 'workshops',
    title: 'Esri India User Conference 2024',
    company: 'Esri India',
    period: 'Sep 2024',
    location: 'Hyderabad, India', locationType: 'On-site',
    lat: 17.42378422371594, lng: 78.46238401853509,
    timelineSummary: 'Attended Esri India UC 2024 — connected with top geospatial professionals and witnessed the latest ArcGIS product releases.',
    popupDetails: 'Had an incredible experience at the ESRI User Conference in Hyderabad! Learned so much, connected with inspiring geospatial professionals, and met Agendra Kumar, Managing Director of ESRI India. Excited to witness the future of GIS with the latest ArcGIS product releases!',
    skills: ['ArcGIS', 'GIS', 'Remote Sensing', 'Geospatial Analytics'],
    images: ['https://media.licdn.com/dms/image/v2/D4D22AQHNX7-yaO2NVg/feedshare-shrink_1280/feedshare-shrink_1280/0/1725977689798?e=1788393600&v=beta&t=rWN63wbwS-HtxR7gg2nf_hpMTDWpiYqW1Dwp3oZKEGQ', 'https://media.licdn.com/dms/image/v2/D4D22AQEzeb0XwvMEaw/feedshare-image-high-res/feedshare-image-high-res/0/1725977692423?e=1788393600&v=beta&t=jeYsLeQvdRaSJgGQX699SW0anxb2I9LwDWELeE-iSSc', 'https://media.licdn.com/dms/image/v2/D4D22AQGI7TNfhLZuyw/feedshare-image-high-res/feedshare-image-high-res/0/1725977695130?e=1788393600&v=beta&t=wY8JbzHHToU_EPc2IyDULCa17JoIrcS6_i0lnzksuRg'],
  },
  {
    id: 22, category: 'workshops',
    title: 'Geo Innovation Challenge 2024 — Winner',
    company: 'Anna University, Chennai, Tamil Nadu',
    period: 'February 2024',
    location: 'Chennai, Tamil Nadu, India', locationType: 'On-site',
    lat: 13.01117165180091, lng: 80.23547286502448,
    timelineSummary: 'Winner of the Geo Innovation Challenge for Sustainable Nation 2024, funded by DST, Government of India.',
    popupDetails: 'Won the Geo Innovation Challenge for Sustainable Nation 2024 at Anna University, Chennai — funded by the Department of Science & Technology (DST), Government of India. The challenge brought together top geospatial innovators from across the country to solve real-world sustainability problems using GIS and AI technologies.',
    skills: ['Python', 'Object Detection', 'Deep Learning', 'GIS', 'Spatial AI'],
    images: ['https://media.licdn.com/dms/image/v2/D5622AQG7Sa1Qxbi9IQ/feedshare-shrink_1280/feedshare-shrink_1280/0/1724860165666?e=1788393600&v=beta&t=JQrQCQ0wtu_cImJzNJmhcjeDkxMlwSoK1F7YOAjNY20', 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGW0F0-2Ic1NyW3h0o0V0wmAGFWFSbkrywSl97hmnXww&s=10',],
  },
  {
    id: 21, category: 'workshops',
    title: 'Five Days Workshop on Recent Developments in Machine Learning and its Applications',
    company: 'IIT Una, Himachal Pradesh',
    period: 'June 2023',
    location: 'Una, Himachal Pradesh, India', locationType: 'On-site',
    lat: 31.48109771287491, lng: 76.18923116449308,
    timelineSummary: 'Intensive workshop on applying AI and machine learning to real world problems.',
    popupDetails: '5-day SERB-sponsored workshop on Recent Developments in Machine Learning and its Applications at IIIT Una, Himachal Pradesh. It was an immensely enriching experience, where we had the opportunity to delve into the latest advancements in the field of machine learning and explore their practical applications.',
    skills: ['Machine Learning', 'Deep Learning', 'Data Analysis'],
    images: ['images/iiit_una_1.jpg', 'images/iiit_una_2.jpg', 'images/iiit_una_3.jpg', 'images/iiit_una_4.jpg'],
  },
];

const travelsData = [
  {
    id: 34, category: 'travels',
    title: 'Lonavla',
    company: 'Maharashtra, India',
    period: 'August 2024',
    location: 'Lonavla, Maharashtra, India', locationType: 'Personal Travel',
    lat: 18.752509631904207, lng: 73.40984764618446,
    timelineSummary: 'Lonavala is a hill station surrounded by green valleys in western India near Mumbai.',
    popupDetails: 'Lonavala is a hill station surrounded by green valleys in western India near Mumbai.',
    images: ['https://travelpal.ai/_next/image?url=https%3A%2F%2Fcdn.travelpal.ai%2Fprod%2Fplaces%2FhC11AlX-jjw9KJt9hkMeWhMb9Ef%2Fphotos%2Fgoogle%2Fwebp%2F18071bc02f5198fae724fba2.webp&w=1440&q=75',],
  },
  {
    id: 33, category: 'travels',
    title: 'Darjeeling',
    company: 'West Bengal, India',
    period: 'September 2018',
    location: 'Darjeeling, India', locationType: 'Personal Travel',
    lat: 27.044785360651936, lng: 88.26767967124493,
    timelineSummary: 'Darjeeling is a town in India\'s West Bengal state, in the Himalayan foothills.',
    popupDetails: 'Darjeeling is a town in India\'s West Bengal state, in the Himalayan foothills.',
    images: ['https://upload.wikimedia.org/wikipedia/commons/2/25/Tea_Estate%2C_Darjeeling.jpg?utm_source=en.wikipedia.org&utm_campaign=index&utm_content=original'],
  },
  {
    id: 32, category: 'travels',
    title: 'Sundarbans',
    company: 'West Bengal, India',
    period: 'September 2017',
    location: 'Sundarbans, India', locationType: 'Personal Travel',
    lat: 21.72486388467073, lng: 88.78687818531593,
    timelineSummary: "One of the world's natural wonders, this massive forest is also a tiger & ecological preserve.",
    popupDetails: "One of the world's natural wonders, this massive forest is also a tiger & ecological preserve.",
    images: ['https://aggrp.in/wp-content/uploads/2025/05/AG-New-Horizon-Blog-Sundarban-April-2025.png',],
  },
  {
    id: 31, category: 'travels',
    title: 'Dooars',
    company: 'North Bengal, India',
    period: 'January 2014',
    location: 'Dooars, India', locationType: 'Personal Travel',
    lat: 26.718622450420803, lng: 88.75082358534766,
    timelineSummary: 'Dooars is a picturesque alluvial floodplain and foothills region in North Bengal, India.',
    popupDetails: 'Dooars is a picturesque alluvial floodplain and foothills region in North Bengal, India',
    images: ['https://hillstarholidays.com/wp-content/uploads/2022/09/Travel-With-SANDIP-1140x641.jpg']
  }
];

const CATEGORIES = [
  { id: 'professional', label: 'Professional' },
  { id: 'education', label: 'Education' },
  { id: 'workshops', label: 'Workshops & Conferences' },
  { id: 'travels', label: 'Travels' },
];

const categoryDataMap = {
  professional: professionalData,
  education: educationData,
  workshops: workshopsData,
  travels: travelsData,
};

// ─── Utils ────────────────────────────────────────────────────────────────────
const calculateDuration = (period) => {
  if (!period || !/[-–]/.test(period)) return null;

  const parts = period.split(/[-–]/).map(p => p.trim());
  if (parts.length !== 2) return null;

  const parseDate = (str) => {
    if (str.toLowerCase() === 'present') return new Date();
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  };

  const start = parseDate(parts[0]);
  const end = parseDate(parts[1]);

  if (!start || !end) return null;

  let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

  // Heuristic: If it has a specific month (string length > 4), make it inclusive.
  if (parts[0].length > 4 || parts[1].length > 4) {
    months += 1;
  }

  if (months <= 0) return null;

  const yrs = Math.floor(months / 12);
  const mos = months % 12;

  const res = [];
  if (yrs > 0) res.push(`${yrs} yr${yrs > 1 ? 's' : ''}`);
  if (mos > 0) res.push(`${mos} mo${mos > 1 ? 's' : ''}`);

  return res.join(' ');
};

// ─── Satellite tile style ─────────────────────────────────────────────────────
const SATELLITE_STYLE = {
  version: 8,
  glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf',
  sky: {
    "sky-color": "#020810",
    "sky-horizon-blend": 0.8,
    "horizon-color": "#ffffff",
    "horizon-fog-blend": 0.8,
    "fog-color": "#8cb7ff",
    "fog-ground-blend": 0.9,
    "atmosphere-blend": [
      "interpolate",
      ["linear"],
      ["zoom"],
      0, 1,
      10, 1,
      12, 0
    ]
  },
  sources: {
    'esri-satellite': {
      type: 'raster',
      tiles: [
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      ],
      tileSize: 256,
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye',
      maxzoom: 19,
    },
    'esri-labels': {
      type: 'raster',
      tiles: [
        'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
      ],
      tileSize: 256,
      maxzoom: 19,
    },
  },
  layers: [
    {
      id: 'background',
      type: 'background',
      paint: { 'background-color': '#020810' }, // deep space — shows inside globe antialias edge
    },
    { id: 'satellite', type: 'raster', source: 'esri-satellite' },
    { id: 'labels', type: 'raster', source: 'esri-labels' },
  ],
};

// ─── Component ────────────────────────────────────────────────────────────────
function Journey() {
  const [activeCategory, setActiveCategory] = useState('professional');
  const [selectedId, setSelectedId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [popupItem, setPopupItem] = useState(null);
  const [is3D, setIs3D] = useState(true);
  const [polylineOn, setPolylineOn] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const markersRef = useRef({});
  const dropdownRef = useRef(null);
  const prevLocationRef = useRef(null);
  const polylineOnRef = useRef(true);

  const currentData = categoryDataMap[activeCategory] || [];
  const activeCategoryLabel = CATEGORIES.find(c => c.id === activeCategory)?.label || '';

  // keep ref in sync so animation callbacks see latest value
  useEffect(() => { polylineOnRef.current = polylineOn; }, [polylineOn]);

  // ── Close dropdown on outside click
  useEffect(() => {
    const h = (e) => { if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  // ── Init map
  useEffect(() => {
    if (mapRef.current) return;
    const map = new maplibregl.Map({
      container: mapContainerRef.current,
      style: SATELLITE_STYLE,
      center: [80.5, 20.5],
      zoom: 1.8,
      pitch: 0,
      bearing: 0,
      antialias: true,
    });

    map.on('load', () => {
      // Globe projection (MapLibre GL JS v3+)
      if (typeof map.setProjection === 'function') {
        map.setProjection({ type: 'globe' });
      }
    });

    map.addControl(new maplibregl.ScaleControl({ unit: 'metric' }), 'bottom-left');
    map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }), 'bottom-left');
    mapRef.current = map;
  }, []);

  // ── Sync markers + polyline when category changes
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;

    // 1. Setup Markers (Synchronous, doesn't require style load)
    Object.values(markersRef.current).forEach(m => m.remove());
    markersRef.current = {};

    currentData.forEach((item) => {
      const container = document.createElement('div');
      container.className = 'map-marker-container';
      container.dataset.id = item.id;

      const el = document.createElement('div');
      el.className = 'map-marker';
      el.style.backgroundImage = "url('/images/mapicons/marker-icon-2x-red.png')";

      container.appendChild(el);

      const marker = new maplibregl.Marker({ element: container, anchor: 'bottom' })
        .setLngLat([item.lng, item.lat])
        .addTo(map);
      container.addEventListener('click', () => handleSelect(item.id));
      markersRef.current[item.id] = marker;
    });

    // 2. Setup Polyline (Asynchronous, requires style load)
    const setupPolyline = () => {
      ['journey-line-bg', 'journey-line'].forEach(id => {
        if (map.getLayer(id)) map.removeLayer(id);
      });
      if (map.getSource('journey-line')) map.removeSource('journey-line');

      const coords = [...currentData].reverse().map(d => [d.lng, d.lat]);
      if (coords.length > 1) {
        map.addSource('journey-line', {
          type: 'geojson',
          data: { type: 'Feature', geometry: { type: 'LineString', coordinates: coords } },
        });
        map.addLayer({
          id: 'journey-line-bg',
          type: 'line',
          source: 'journey-line',
          paint: {
            'line-color': '#3A6EA5',
            'line-width': 6,
            'line-opacity': 0.15,
            'line-blur': 4,
          },
          layout: { 'visibility': polylineOnRef.current ? 'visible' : 'none' },
        });
        map.addLayer({
          id: 'journey-line',
          type: 'line',
          source: 'journey-line',
          paint: {
            'line-color': '#3A6EA5',
            'line-width': 1.8,
            'line-opacity': 0.65,
            'line-dasharray': [5, 5],
          },
          layout: { 'visibility': polylineOnRef.current ? 'visible' : 'none' },
        });
      }
    };

    const trySetupPolyline = () => {
      if (!map.isStyleLoaded()) {
        map.once('styledata', trySetupPolyline);
      } else {
        setupPolyline();
      }
    };
    trySetupPolyline();

    return () => {
      Object.values(markersRef.current).forEach(m => m.remove());
      markersRef.current = {};
      if (map.getLayer('journey-line-bg')) map.removeLayer('journey-line-bg');
      if (map.getLayer('journey-line')) map.removeLayer('journey-line');
      if (map.getSource('journey-line')) map.removeSource('journey-line');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCategory]);

  // ── Polyline visibility toggle
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !map.isStyleLoaded()) return;
    const vis = polylineOn ? 'visible' : 'none';
    if (map.getLayer('journey-line')) map.setLayoutProperty('journey-line', 'visibility', vis);
    if (map.getLayer('journey-line-bg')) map.setLayoutProperty('journey-line-bg', 'visibility', vis);
  }, [polylineOn]);

  // ── Handle item selection
  const handleSelect = useCallback((id) => {
    const map = mapRef.current;

    setSelectedId(prev => {
      if (prev === id) {
        setPopupItem(null);
        prevLocationRef.current = null;

        // Restore view on deselect
        if (map) {
          if (is3D) {
            if (typeof map.setProjection === 'function') map.setProjection({ type: 'globe' });
            map.flyTo({ center: [80.5, 20.5], zoom: 1.8, pitch: 0, bearing: 0, duration: 2500 });
          } else {
            map.flyTo({ center: [80.5, 20.5], zoom: 4.5, pitch: 0, bearing: 0, duration: 2500 });
          }
        }

        // Clear marker active states
        setTimeout(() => {
          Object.values(markersRef.current).forEach(marker => {
            marker.getElement().classList.remove('active');
          });
        }, 0);

        return null;
      }

      const item = [...professionalData, ...educationData, ...workshopsData, ...travelsData]
        .find(d => d.id === id);
      if (!item) return id;

      const dest = { lat: item.lat, lng: item.lng };
      prevLocationRef.current = dest;

      // Map camera — switch to mercator/flat when zooming into a location
      if (map) {
        // If currently in globe mode, drop back to mercator for the close-up
        if (is3D && typeof map.setProjection === 'function') {
          map.setProjection({ type: 'mercator' });
        }
        map.flyTo({
          center: [item.lng, item.lat],
          zoom: 12,
          pitch: 30,
          bearing: -10,
          duration: 3500,
          essential: true,
        });
      }

      setPopupItem(item);
      setCurrentImageIndex(0);

      // Update marker active states
      setTimeout(() => {
        Object.entries(markersRef.current).forEach(([mid, marker]) => {
          marker.getElement().classList.toggle('active', Number(mid) === id);
        });
      }, 0);

      return id;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is3D]);

  // ── Globe / 2D toggle
  const toggle3D = () => {
    const map = mapRef.current;
    if (!map) return;
    const next3D = !is3D;
    setIs3D(next3D);
    if (next3D) {
      if (typeof map.setProjection === 'function') map.setProjection({ type: 'globe' });
      if (typeof map.setFog === 'function') {
        map.setFog({
          'color': 'rgba(10, 30, 60, 0.6)',
          'high-color': 'rgba(5, 15, 40, 1)',
          'horizon-blend': 0.08,
          'space-color': '#030a18',
          'star-intensity': 0.6,
        });
      }
      map.flyTo({ center: [80.5, 20.5], zoom: 1.8, pitch: 0, bearing: 0, duration: 900 });
    } else {
      if (typeof map.setProjection === 'function') map.setProjection({ type: 'mercator' });
      if (typeof map.setFog === 'function') map.setFog(null);
      map.flyTo({ center: [80.5, 20.5], zoom: 4.5, pitch: 0, bearing: 0, duration: 900 });
    }
  };

  // ── Category change
  const handleCategoryChange = (catId) => {
    setActiveCategory(catId);
    setSelectedId(null);
    setPopupItem(null);
    setDropdownOpen(false);
    prevLocationRef.current = null;
    if (is3D) {
      const map = mapRef.current;
      if (map) {
        if (typeof map.setProjection === 'function') map.setProjection({ type: 'globe' });
        map.flyTo({ center: [80.5, 20.5], zoom: 1.8, pitch: 0, bearing: 0, duration: 800 });
      }
    } else {
      mapRef.current?.flyTo({ center: [80.5, 20.5], zoom: 4.5, pitch: 0, bearing: 0, duration: 800 });
    }
  };

  return (
    <section className="journey">
      <div className="journey-layout">

        {/* ── Sidebar ── */}
        <aside className="journey-sidebar">
          <div className="sidebar-header">
            {/* <p className="sidebar-eyebrow">Interactive Timeline</p> */}
            <h2 className="sidebar-title">My Journey</h2>

            <div className="category-dropdown" ref={dropdownRef}>
              <button
                className={`dropdown-trigger ${dropdownOpen ? 'open' : ''}`}
                onClick={() => setDropdownOpen(o => !o)}
                aria-haspopup="listbox"
                aria-expanded={dropdownOpen}
              >
                <span>{activeCategoryLabel}</span>
                <svg className="dropdown-chevron" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3 5L7 9L11 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              {dropdownOpen && (
                <ul className="dropdown-menu" role="listbox">
                  {CATEGORIES.map(cat => (
                    <li
                      key={cat.id}
                      role="option"
                      aria-selected={cat.id === activeCategory}
                      className={`dropdown-option ${cat.id === activeCategory ? 'selected' : ''}`}
                      onClick={() => handleCategoryChange(cat.id)}
                    >
                      {cat.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="timeline-scroll">
            <div className="timeline-track">
              {currentData.map((item, idx) => (
                <div
                  key={item.id}
                  className={`timeline-item ${selectedId === item.id ? 'active' : ''}`}
                  onClick={() => handleSelect(item.id)}
                >
                  <div className="track-line-wrap">
                    <div className="track-dot" />
                    {idx < currentData.length - 1 && <div className="track-connector" />}
                  </div>
                  <div className="timeline-card">
                    <span className="card-period">
                      {item.period}
                      {calculateDuration(item.period) && ` • ${calculateDuration(item.period)}`}
                    </span>
                    <h3 className="card-title">{item.title}</h3>
                    <p className="card-company">
                      {item.company}
                      {item.website && (
                        <a href={item.website} target="_blank" rel="noopener noreferrer" className="company-link" onClick={(e) => e.stopPropagation()}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '4px', verticalAlign: 'middle', display: 'inline-block', paddingBottom: '2px' }}>
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="2" y1="12" x2="22" y2="12"></line>
                            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                          </svg>
                        </a>
                      )}
                    </p>
                    {(item.cgpa || item.grade) && (
                      <span className="card-grade">
                        {item.cgpa ? `CGPA ${item.cgpa}` : `Grade ${item.grade}`}
                      </span>
                    )}
                    <p className="card-summary">{item.timelineSummary}</p>
                    <span className="card-location">{item.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </aside>

        {/* ── Map ── */}
        <div className="journey-map-wrap">
          <div className="starfield-bg"></div>
          <div className="globe-atmosphere"></div>
          <div ref={mapContainerRef} className="journey-map" />

          {/* Map controls toolbar */}
          <div className="map-toolbar">
            <button
              className={`map-ctrl-btn ${is3D ? 'active' : ''}`}
              onClick={toggle3D}
              title={is3D ? 'Switch to flat 2D map' : 'Switch to 3D globe'}
            >
              <span className="ctrl-label">{is3D ? 'Globe' : 'Flat'}</span>
              <span className="ctrl-sub">{is3D ? '3D' : '2D'}</span>
            </button>

            <div className="map-ctrl-divider" />

            <button
              className={`map-ctrl-btn ${polylineOn ? 'active' : ''}`}
              onClick={() => setPolylineOn(v => !v)}
              title={polylineOn ? 'Hide route' : 'Show route'}
            >
              <svg width="18" height="10" viewBox="0 0 18 10" fill="none">
                <path d="M1 9 Q5 1 9 5 Q13 9 17 1" stroke={polylineOn ? '#3A6EA5' : 'rgba(245,237,214,0.25)'}
                  strokeWidth="2" strokeLinecap="round" fill="none" strokeDasharray="3 2" />
              </svg>
              <span className="ctrl-sub">{polylineOn ? 'Route on' : 'Route off'}</span>
            </button>
          </div>

          {/* Popup panel */}
          {popupItem && (
            <div className="map-popup-panel">
              <button className="popup-close" onClick={() => handleSelect(popupItem.id)}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </button>

              {(popupItem.images || popupItem.image) && (
                <div className="popup-img-wrap">
                  {popupItem.images && popupItem.images.length > 1 ? (
                    <>
                      <img
                        src={popupItem.images[currentImageIndex]}
                        alt={popupItem.title}
                        className="popup-img"
                        onClick={() => setIsMaximized(true)}
                      />
                      <button
                        className="img-nav-btn prev"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex(prev => (prev - 1 + popupItem.images.length) % popupItem.images.length);
                        }}
                      >
                        ‹
                      </button>
                      <button
                        className="img-nav-btn next"
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex(prev => (prev + 1) % popupItem.images.length);
                        }}
                      >
                        ›
                      </button>
                      <div className="img-dots">
                        {popupItem.images.map((_, idx) => (
                          <span
                            key={idx}
                            className={`img-dot ${idx === currentImageIndex ? 'active' : ''}`}
                            onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(idx); }}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <img
                      src={popupItem.image || (popupItem.images && popupItem.images[0])}
                      alt={popupItem.title}
                      className="popup-img"
                      onClick={() => setIsMaximized(true)}
                    />
                  )}
                </div>
              )}

              <div className="popup-body">
                <span className="popup-period">
                  {popupItem.period}
                  {calculateDuration(popupItem.period) && ` • ${calculateDuration(popupItem.period)}`}
                </span>
                <h3 className="popup-title">{popupItem.title}</h3>
                <p className="popup-company">
                  {popupItem.company}
                  {popupItem.website && (
                    <a href={popupItem.website} target="_blank" rel="noopener noreferrer" className="company-link">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '4px', verticalAlign: 'middle', display: 'inline-block', paddingBottom: '1px' }}>
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                      </svg>
                    </a>
                  )}
                </p>
                {(popupItem.cgpa || popupItem.grade) && (
                  <p className="popup-grade">
                    {popupItem.cgpa ? `CGPA: ${popupItem.cgpa} / 10` : `Grade: ${popupItem.grade}`}
                  </p>
                )}

                <div className="popup-section">
                  <span className="popup-label">About</span>
                  <p className="popup-text">{popupItem.popupDetails}</p>
                </div>

                {popupItem.skills?.length > 0 && (
                  <div className="popup-section">
                    <span className="popup-label">Skills</span>
                    <div className="popup-skills">
                      {popupItem.skills.map((s, i) => (
                        <span key={i} className="popup-skill">{s}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

      </div>

      {/* Maximized Image Overlay */}
      {isMaximized && popupItem && (
        <div className="maximized-img-overlay" onClick={() => setIsMaximized(false)}>
          <button className="maximized-img-close" onClick={() => setIsMaximized(false)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
          <div className="maximized-img-wrapper" onClick={(e) => e.stopPropagation()}>
            {popupItem.images && popupItem.images.length > 1 ? (
              <>
                <img src={popupItem.images[currentImageIndex]} alt="Maximized view" className="maximized-img-content" />
                <button
                  className="max-nav-btn prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(prev => (prev - 1 + popupItem.images.length) % popupItem.images.length);
                  }}
                >
                  ‹
                </button>
                <button
                  className="max-nav-btn next"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentImageIndex(prev => (prev + 1) % popupItem.images.length);
                  }}
                >
                  ›
                </button>
              </>
            ) : (
              <img src={popupItem.image || (popupItem.images && popupItem.images[0])} alt="Maximized view" className="maximized-img-content" />
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default Journey;